import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  UserOutline,
  LockOutline,
  MailOutline,
  UserAddOutline,
  LoginOutline,
  LogoutOutline,
  SettingOutline,
  FileTextOutline,
  PlusCircleOutline,
  CheckCircleOutline,
  SendOutline,
  InfoCircleOutline,
  TeamOutline,
  LayoutOutline,
  DownOutline
} from '@ant-design/icons-angular/icons';

export const icons = [
  MenuFoldOutline, 
  MenuUnfoldOutline, 
  DashboardOutline, 
  FormOutline,
  UserOutline,
  LockOutline,
  MailOutline,
  UserAddOutline,
  LoginOutline,
  LogoutOutline,
  SettingOutline,
  FileTextOutline,
  PlusCircleOutline,
  CheckCircleOutline,
  SendOutline,
  InfoCircleOutline,
  TeamOutline,
  LayoutOutline,
  DownOutline
];
